export default __webpack_public_path__ + "static/Choose-spin-the-wheel-template-0e6ac147db2ba4b6bbbcb5d5fe02cef5.png";